@if (solutionSpace$ | async; as solutionSpace) { @if (component$ | async; as component) {
<app-component-detail
  [solutionSpace]="solutionSpace"
  [isProjectComponent]="isProjectComponent"
  [component]="component"
  [trackingPoints$]="trackingPoints$"
  [datalogs$]="datalogs$"
  [componentActivities$]="componentActivities$"
  [utilizationStatistics$]="utilizationStatistics$"
  (updateDateRangeTrackingPoints)="updateTackingPoints($event)"
  (updateDateRangeMeasurements)="updateMeasurements($event)"
  (refreshActivities)="refreshActivities()"
></app-component-detail>
} }
